import React, { useState, useEffect } from "react";
import axios from 'axios';
import AWS from 'aws-sdk';
import { notification } from 'antd';
import AudioPlayer from '../AudioPlayer';

const Card = () => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOption, setSelectedOption] = useState('option2');
    const [dropDown, setDropDown] = useState(false);
    const [audioUrl, setAudioUrl] = useState('');
    const [audioUrlload, setaudioUrlload] = useState(false);
    const [currentLectureName, setCurrentLectureName] = useState('');
    const [search, setSearch] = useState("");
    const [activeLectureUrl, setActiveLectureUrl] = useState('');
    const [currentParts, setCurrentParts] = useState([]);
    const [currentPartIndex, setCurrentPartIndex] = useState(-1);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post('/api/getLecture', { type: "Tafseer ul Quran class" });
                setData(response.data.reverse());
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const filteredData = data ? data.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    ) : [];

    const handleOptionChange = (event) => {
        setData(data.reverse());
        setSelectedOption(event.target.value);
        console.log(event.target.value);
    };

    const DropDownFunc = () => {
        setDropDown(!dropDown);
    };

    const handleLinkClick = (url, lectureName, originalUrl, parts, partIndex) => {
        setaudioUrlload(false);
        if (originalUrl) setActiveLectureUrl(originalUrl);
        else setActiveLectureUrl('');
        setCurrentParts(parts || []);
        setCurrentPartIndex(partIndex !== undefined ? partIndex : -1);
        const regex = /id=([^&]+)/;
        const idMatch = url.match(regex);
        console.log(idMatch);
        if (idMatch) {
            const id = idMatch[1];
            const s3 = new AWS.S3({
                endpoint: 's3.wasabisys.com',
                accessKeyId: 'I8ITVDL3GT2TQA0ZFSAB',
                secretAccessKey: 'DszVpDdzqP1si8PUybJQ3ae3784AJ1vTSN2sqRTq',
                region: 'us-east-1'
            });
            const params = {
                Bucket: 'sakeenat',
                Key: `${id}.mp4`,
                Expires: 60
            };
            s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) {
                    notification.error({ message: "Unable to open this lecture" });
                    console.log('error', err);
                } else {
                    setAudioUrl(url);
                    setCurrentLectureName(lectureName);
                    setaudioUrlload(true);
                }
            });
        }
    };

    function removeSpecificPhrase(inputString, phraseToRemove) {
        return inputString.replace(new RegExp(phraseToRemove, 'g'), '');
    }

    if (isLoading) {
        return (
            <div className="al-container">
                <div className="al-loading"><div className="al-spinner" />Loading lectures...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="al-container">
                <div className="al-error">Failed to load lectures. Please try again.</div>
            </div>
        );
    }

    return (
        <div className="al-container">
            {/* Legacy recordings dropdown */}
            <button className="al-legacy-toggle" onClick={DropDownFunc}>
                {dropDown ? 'Hide' : 'Show'} Legacy Lectures 2019 #1 - #3
            </button>
            {dropDown && (
                <div className="al-legacy-list">
                    <li>0009 TQ- "SURAH AL BAQARAH " Ayat # 21 to 29 Thursday DEC 12th 2019 by Aalimah Nikhat Haider Aapa</li>
                    <div className="al-legacy-links">
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1TD8T06hs84UdquJj2hJliSnuEdMS9zKl&export=download", "Legacy Lecture 1")}>Lec 1</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=18o8hlp9dgeQ3T5qeo85k_7z26--up5af&export=download", "Legacy Lecture 2")}>Lec 2</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=15SIrxrWnLwpCMHtFHbGuufKbm8PZYzu3&export=download", "Legacy Lecture 3")}>Lec 3</button>
                    </div>
                </div>
            )}

            {/* Toolbar */}
            <div className="al-toolbar">
                <div className="al-toolbar-left">
                    <span className="al-lecture-count">{filteredData.length} lecture{filteredData.length !== 1 ? 's' : ''}</span>
                    <select className="al-sort" value={selectedOption} onChange={handleOptionChange}>
                        <option value="option1">Oldest first</option>
                        <option value="option2">Newest first</option>
                    </select>
                </div>
                <div className="al-search-wrapper">
                    <span className="al-search-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="al-search"
                        placeholder="Search in Tafseer ul Quran..."
                        value={search}
                        onChange={handleSearchChange}
                    />
                </div>
            </div>

            {/* Table header */}
            <div className="al-list-header">
                <span>#</span>
                <span>Title</span>
                <span className="al-header-parts">Parts</span>
                <span></span>
            </div>

            {/* Lecture rows */}
            <div className="al-list" style={{ marginBottom: audioUrl ? '100px' : '0' }}>
                {filteredData.length === 0 && <div className="al-empty">No lectures found.</div>}
                {filteredData.map((cur, index) => {
                    const cleanName = removeSpecificPhrase(cur.name, "By: Aalima Nikhat Haider Aapa");
                    const isActive = currentLectureName === cleanName;
                    return (
                        <div key={cur['_id']} className={`al-row ${isActive ? 'al-row-active' : ''}`}>
                            <span className="al-col-num">{index + 1}</span>
                            <div className="al-col-title-group">
                                <span className="al-col-title" title={cleanName}>{cleanName}</span>
                                {cur.date && <span className="al-col-date">{cur.date}</span>}
                            </div>
                            <div className="al-col-parts">
                                {cur.lectures.map((i, r) => (
                                    <button key={r} className={`al-play-chip ${activeLectureUrl === i ? 'al-play-chip-active' : ''}`} onClick={() => handleLinkClick(i, cleanName, i, cur.lectures, r)}>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                                        {r + 1}
                                    </button>
                                ))}
                            </div>
                            <span className="al-col-actions"></span>
                        </div>
                    );
                })}
            </div>

            {audioUrl && (
                <AudioPlayer
                    src={audioUrl}
                    isLoading={!audioUrlload}
                    title={currentLectureName}
                    subtitle="Tafseer ul Quran Class"
                    hasPrev={currentPartIndex > 0}
                    hasNext={currentPartIndex < currentParts.length - 1}
                    onPrev={() => {
                        if (currentPartIndex > 0) {
                            const prevUrl = currentParts[currentPartIndex - 1];
                            handleLinkClick(prevUrl, currentLectureName, prevUrl, currentParts, currentPartIndex - 1);
                        }
                    }}
                    onNext={() => {
                        if (currentPartIndex < currentParts.length - 1) {
                            const nextUrl = currentParts[currentPartIndex + 1];
                            handleLinkClick(nextUrl, currentLectureName, nextUrl, currentParts, currentPartIndex + 1);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default Card;
